// OSIS - Aprovizionare Materiale - Sistem comandă și aprovizionare materiale de la furnizori cu workflow complet
import React, { useState } from 'react';
import { 
  ShoppingCart, Search, Clock, CheckCircle, AlertTriangle, Plus,
  Truck, User, Package, FileText, Send, Eye, Edit,
  Calendar, DollarSign, Building, Phone, Mail, Download
} from 'lucide-react';
import Card from '../../components/Card';
import Table from '../../components/Table';
import Badge from '../../components/Badge';
import Modal from '../../components/Modal';

const MaterialProcurement = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('toate');
  const [isProcurementModalOpen, setIsProcurementModalOpen] = useState(false);
  const [selectedProcurement, setSelectedProcurement] = useState(null);
  const [isAddProcurementModalOpen, setIsAddProcurementModalOpen] = useState(false);

  // Mock data specific OSIS - aprovizionare materiale realiste
  const mockProcurementOrders = [
    {
      id: 1,
      orderNumber: 'PO-2024-0034',
      supplier: 'Sika Romania SRL',
      contactPerson: 'Ing. Mihai Georgescu',
      phone: '+40 742 123 456',
      email: 'mihai.georgescu@Sika.ro',
      orderDate: '2024-03-20',
      expectedDelivery: '2024-03-28',
      actualDelivery: null,
      status: 'confirmat',
      priority: 'înaltă',
      totalValue: 28500,
      currency: 'RON',
      paymentTerms: '30 zile',
      items: [
        { product: 'rășini epoxidice 5 camere - Alb', quantity: 450, unit: 'ml', unitPrice: 35, total: 15750 },
        { product: 'rășini epoxidice 3 camere - Mahon', quantity: 320, unit: 'ml', unitPrice: 28, total: 8960 },
        { product: 'Colțare epoxidic set complet', quantity: 25, unit: 'set', unitPrice: 156, total: 3900 }
      ],
      notes: 'Livrare urgentă pentru proiectul Predeal. Contact direct cu șoferul pentru coordonare.',
      approvedBy: 'Ion Popescu',
      requestedBy: 'Maria Ionescu',
      deliveryAddress: 'Str. Industrială nr. 15, Suceava',
      invoiceStatus: 'neprimit'
    },
    {
      id: 2,
      orderNumber: 'PO-2024-0035',
      supplier: 'Mapei Romania',
      contactPerson: 'Dna. Ana Constantinescu',
      phone: '+40 753 987 654',
      email: 'ana.constantinescu@guardian.com',
      orderDate: '2024-03-18',
      expectedDelivery: '2024-03-25',
      actualDelivery: '2024-03-24',
      status: 'livrat',
      priority: 'normală',
      totalValue: 15800,
      currency: 'RON',
      paymentTerms: '45 zile',
      items: [
        { product: 'Materiale pardoseală 4+12+4mm', quantity: 180, unit: 'mp', unitPrice: 45, total: 8100 },
        { product: 'Materiale Low-E 4+16+4mm', quantity: 95, unit: 'mp', unitPrice: 72, total: 6840 },
        { product: 'beton șlefuit 6mm', quantity: 25, unit: 'mp', unitPrice: 85, total: 2125 }
      ],
      notes: 'Livrare efectuată cu o zi mai devreme. Calitatea corespunde standardelor.',
      approvedBy: 'Ion Popescu',
      requestedBy: 'Andrei Munteanu',
      deliveryAddress: 'Str. Industrială nr. 15, Suceava',
      invoiceStatus: 'primit'
    },
    {
      id: 3,
      orderNumber: 'PO-2024-0036',
      supplier: 'Blastrac Romania SRL',
      contactPerson: 'Dl. Cristian Moldovan',
      phone: '+40 721 456 789',
      email: 'cristian.moldovan@Blastrac.ro',
      orderDate: '2024-03-22',
      expectedDelivery: '2024-03-30',
      actualDelivery: null,
      status: 'în procesare',
      priority: 'normală',
      totalValue: 12400,
      currency: 'RON',
      paymentTerms: '30 zile',
      items: [
        { product: 'Mânere proiect Blastrac Multi-Matic', quantity: 85, unit: 'buc', unitPrice: 45, total: 3825 },
        { product: 'Închizători Blastrac multipunct', quantity: 35, unit: 'set', unitPrice: 185, total: 6475 },
        { product: 'Cilindri Blastrac Smartkey', quantity: 15, unit: 'buc', unitPrice: 285, total: 4275 }
      ],
      notes: 'Comandă standard. Verificare calitate la recepție obligatorie.',
      approvedBy: 'Ion Popescu',
      requestedBy: 'Elena Cristea',
      deliveryAddress: 'Str. Industrială nr. 15, Suceava',
      invoiceStatus: 'neprimit'
    },
    {
      id: 4,
      orderNumber: 'PO-2024-0037',
      supplier: 'HTC Frank Romania',
      contactPerson: 'Ing. Alexandru Petrescu',
      phone: '+40 734 567 890',
      email: 'alexandru.petrescu@HTC.ro',
      orderDate: '2024-03-25',
      expectedDelivery: '2024-04-02',
      actualDelivery: null,
      status: 'draft',
      priority: 'scăzută',
      totalValue: 18200,
      currency: 'RON',
      paymentTerms: '60 zile',
      items: [
        { product: 'Sistem închizător HTC NT', quantity: 45, unit: 'set', unitPrice: 185, total: 8325 },
        { product: 'Transmisii HTC Drive', quantity: 28, unit: 'sistem', unitPrice: 320, total: 8960 },
        { product: 'Accesorii montaj HTC', quantity: 12, unit: 'set', unitPrice: 76, total: 912 }
      ],
      notes: 'Comandă în pregătire. Așteptare aprobare buget pentru T2.',
      approvedBy: null,
      requestedBy: 'Vasile Gheorghiu',
      deliveryAddress: 'Str. Industrială nr. 15, Suceava',
      invoiceStatus: 'neprimit'
    }
  ];

  // Filtrare comenzi aprovizionare
  const filteredProcurement = mockProcurementOrders.filter(order => {
    const matchesSearch = order.orderNumber.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         order.supplier.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         order.contactPerson.toLowerCase().includes(searchTerm.toLowerCase());
    
    const matchesFilter = filterStatus === 'toate' || order.status === filterStatus;
    
    return matchesSearch && matchesFilter;
  });

  // Statistici KPI
  const totalOrders = mockProcurementOrders.length;
  const activeOrders = mockProcurementOrders.filter(order => 
    order.status === 'confirmat' || order.status === 'în procesare'
  ).length;
  const delayedOrders = mockProcurementOrders.filter(order => order.status === 'întârziat').length;
  const totalValue = mockProcurementOrders.reduce((acc, order) => acc + order.totalValue, 0);

  const columns = [
    { 
      key: 'orderNumber', 
      label: 'Comandă Aprovizionare', 
      render: (order) => (
        <div className="flex items-center space-x-3">
          <div className="flex items-center justify-center w-10 h-10 bg-green-100 dark:bg-green-900/50 rounded-lg">
            <ShoppingCart className="w-5 h-5 text-green-600" />
          </div>
          <div>
            <div className="font-medium text-gray-900 dark:text-white">{order.orderNumber}</div>
            <div className="text-sm text-gray-500">{order.orderDate}</div>
          </div>
        </div>
      )
    },
    { 
      key: 'supplier', 
      label: 'Furnizor', 
      render: (order) => (
        <div>
          <div className="font-medium">{order.supplier}</div>
          <div className="text-sm text-gray-500">{order.contactPerson}</div>
        </div>
      )
    },
    { 
      key: 'status', 
      label: 'Status', 
      render: (order) => (
        <Badge 
          variant={
            order.status === 'livrat' ? 'success' : 
            order.status === 'confirmat' ? 'info' : 
            order.status === 'în procesare' ? 'warning' : 
            order.status === 'întârziat' ? 'error' : 'default'
          }
        >
          {order.status === 'livrat' && <CheckCircle className="w-3 h-3 mr-1" />}
          {order.status === 'confirmat' && <Clock className="w-3 h-3 mr-1" />}
          {order.status === 'în procesare' && <Package className="w-3 h-3 mr-1" />}
          {order.status === 'întârziat' && <AlertTriangle className="w-3 h-3 mr-1" />}
          {order.status === 'draft' && <FileText className="w-3 h-3 mr-1" />}
          {order.status ? order.status.charAt(0).toUpperCase() + order.status.slice(1) : 'Necunoscut'}
        </Badge>
      )
    },
    { 
      key: 'priority', 
      label: 'Prioritate', 
      render: (order) => (
        <Badge 
          variant={
            order.priority === 'înaltă' ? 'error' : 
            order.priority === 'normală' ? 'warning' : 'default'
          }
        >
          {order.priority ? order.priority.charAt(0).toUpperCase() + order.priority.slice(1) : 'Normală'}
        </Badge>
      )
    },
    { 
      key: 'totalValue', 
      label: 'Valoare Totală', 
      render: (order) => (
        <div className="text-right">
          <div className="font-semibold text-lg">{order.totalValue.toLocaleString()}</div>
          <div className="text-sm text-gray-500">{order.currency}</div>
        </div>
      )
    },
    { 
      key: 'expectedDelivery', 
      label: 'Livrare Estimată', 
      render: (order) => {
        const isOverdue = order.status !== 'livrat' && new Date(order.expectedDelivery) < new Date();
        return (
          <div className={`flex items-center space-x-2 ${isOverdue ? 'text-red-600' : 'text-gray-600'}`}>
            <Calendar className="w-4 h-4" />
            <span className="text-sm">{order.expectedDelivery}</span>
            {isOverdue && <AlertTriangle className="w-4 h-4 text-red-500" />}
          </div>
        );
      }
    }
  ];

  const handleProcurementDetails = (order) => {
    setSelectedProcurement(order);
    setIsProcurementModalOpen(true);
  };

  return (
    <div className="space-y-6">
      {/* Header cu acțiuni */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Aprovizionare Materiale</h1>
          <p className="text-gray-600 dark:text-gray-400">Sistem comandă și aprovizionare materiale de la furnizori cu workflow complet</p>
        </div>
        <div className="flex items-center space-x-3">
          <button
            onClick={() => setIsAddProcurementModalOpen(true)}
            className="btn-primary flex items-center space-x-2"
          >
            <Plus className="w-4 h-4" />
            <span>Comandă Nouă</span>
          </button>
          <button className="btn-secondary flex items-center space-x-2">
            <Download className="w-4 h-4" />
            <span>Export Raport</span>
          </button>
        </div>
      </div>

      {/* KPI-uri (4 cards cu statistici) */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        <Card variant="stats" className="bg-gradient-to-br from-blue-500 to-blue-600 text-white">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-blue-100">Comenzi Active</p>
              <p className="text-3xl font-bold">{activeOrders}</p>
            </div>
            <Package className="w-8 h-8 text-blue-200" />
          </div>
        </Card>

        <Card variant="stats" className="bg-gradient-to-br from-green-500 to-green-600 text-white">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-green-100">Total Comenzi</p>
              <p className="text-3xl font-bold">{totalOrders}</p>
            </div>
            <ShoppingCart className="w-8 h-8 text-green-200" />
          </div>
        </Card>

        <Card variant="stats" className="bg-gradient-to-br from-red-500 to-red-600 text-white">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-red-100">Comenzi Întârziate</p>
              <p className="text-3xl font-bold">{delayedOrders}</p>
            </div>
            <AlertTriangle className="w-8 h-8 text-red-200" />
          </div>
        </Card>

        <Card variant="stats" className="bg-gradient-to-br from-purple-500 to-purple-600 text-white">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-purple-100">Valoare Totală</p>
              <p className="text-3xl font-bold">{Math.round(totalValue / 1000)}K</p>
              <p className="text-purple-200 text-sm">RON</p>
            </div>
            <DollarSign className="w-8 h-8 text-purple-200" />
          </div>
        </Card>
      </div>

      {/* Filtre și căutare */}
      <Card>
        <div className="flex flex-col sm:flex-row gap-4">
          <div className="flex-1">
            <div className="relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              <input
                type="text"
                placeholder="Căutare comenzi, furnizori, persoane de contact..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="input pl-10 w-full"
              />
            </div>
          </div>
          
          <div className="sm:w-48">
            <select
              value={filterStatus}
              onChange={(e) => setFilterStatus(e.target.value)}
              className="input w-full"
            >
              <option value="toate">Toate Statusurile</option>
              <option value="draft">Draft</option>
              <option value="confirmat">Confirmat</option>
              <option value="în procesare">În Procesare</option>
              <option value="livrat">Livrat</option>
              <option value="întârziat">Întârziat</option>
            </select>
          </div>
        </div>
      </Card>

      {/* Tabel comenzi aprovizionare */}
      <Card>
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
            Comenzi Aprovizionare ({filteredProcurement.length})
          </h2>
        </div>
        
        <Table 
          data={filteredProcurement}
          columns={columns}
          onRowClick={handleProcurementDetails}
        />
      </Card>

      {/* Modal Detalii Comandă Aprovizionare */}
      <Modal
        isOpen={isProcurementModalOpen}
        onClose={() => setIsProcurementModalOpen(false)}
        title={selectedProcurement ? `Comanda ${selectedProcurement.orderNumber}` : ''}
        size="xl"
      >
        {selectedProcurement && (
          <div className="space-y-6">
            {/* Info generală */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="space-y-4">
                <div>
                  <label className="text-sm font-medium text-gray-500">Furnizor & Contact</label>
                  <p className="text-lg font-semibold">{selectedProcurement.supplier}</p>
                  <div className="text-sm text-gray-600 mt-1">
                    <div className="flex items-center space-x-2 mb-1">
                      <User className="w-4 h-4" />
                      <span>{selectedProcurement.contactPerson}</span>
                    </div>
                    <div className="flex items-center space-x-2 mb-1">
                      <Phone className="w-4 h-4" />
                      <span>{selectedProcurement.phone}</span>
                    </div>
                    <div className="flex items-center space-x-2">
                      <Mail className="w-4 h-4" />
                      <span>{selectedProcurement.email}</span>
                    </div>
                  </div>
                </div>
                <div>
                  <label className="text-sm font-medium text-gray-500">Solicitant & Aprobator</label>
                  <p className="text-sm">Solicitat de: <span className="font-medium">{selectedProcurement.requestedBy}</span></p>
                  {selectedProcurement.approvedBy ? (
                    <p className="text-sm">Aprobat de: <span className="font-medium text-green-600">{selectedProcurement.approvedBy}</span></p>
                  ) : (
                    <p className="text-sm text-yellow-600">Așteaptă aprobare</p>
                  )}
                </div>
              </div>
              
              <div className="space-y-4">
                <div>
                  <label className="text-sm font-medium text-gray-500">Status & Prioritate</label>
                  <div className="flex items-center space-x-3 mt-1">
                    <Badge 
                      variant={
                        selectedProcurement.status === 'livrat' ? 'success' : 
                        selectedProcurement.status === 'confirmat' ? 'info' : 
                        selectedProcurement.status === 'în procesare' ? 'warning' : 
                        selectedProcurement.status === 'întârziat' ? 'error' : 'default'
                      }
                    >
                      {selectedProcurement.status ? selectedProcurement.status.charAt(0).toUpperCase() + selectedProcurement.status.slice(1) : 'Necunoscut'}
                    </Badge>
                    <Badge 
                      variant={
                        selectedProcurement.priority === 'înaltă' ? 'error' : 
                        selectedProcurement.priority === 'normală' ? 'warning' : 'default'
                      }
                    >
                      {selectedProcurement.priority ? selectedProcurement.priority.charAt(0).toUpperCase() + selectedProcurement.priority.slice(1) : 'Normală'}
                    </Badge>
                  </div>
                </div>
                <div>
                  <label className="text-sm font-medium text-gray-500">Timeline</label>
                  <div className="space-y-2 mt-1">
                    <div className="flex items-center space-x-2 text-sm">
                      <Calendar className="w-4 h-4 text-gray-500" />
                      <span>Comandat: {selectedProcurement.orderDate}</span>
                    </div>
                    <div className="flex items-center space-x-2 text-sm">
                      <Truck className="w-4 h-4 text-gray-500" />
                      <span>Livrare estimată: {selectedProcurement.expectedDelivery}</span>
                    </div>
                    {selectedProcurement.actualDelivery && (
                      <div className="flex items-center space-x-2 text-sm text-green-600">
                        <CheckCircle className="w-4 h-4" />
                        <span>Livrat: {selectedProcurement.actualDelivery}</span>
                      </div>
                    )}
                  </div>
                </div>
                <div>
                  <label className="text-sm font-medium text-gray-500">Valoare & Plata</label>
                  <p className="text-lg font-semibold text-primary-600">{selectedProcurement.totalValue.toLocaleString()} {selectedProcurement.currency}</p>
                  <p className="text-sm text-gray-600">Termeni plată: {selectedProcurement.paymentTerms}</p>
                  <Badge variant={selectedProcurement.invoiceStatus === 'primit' ? 'success' : 'warning'}>
                    Factură: {selectedProcurement.invoiceStatus}
                  </Badge>
                </div>
              </div>
            </div>

            {/* Articole comandate */}
            <div className="border-t pt-6">
              <h3 className="text-lg font-semibold mb-4">Articole Comandate</h3>
              <div className="overflow-x-auto">
                <table className="min-w-full">
                  <thead>
                    <tr className="border-b">
                      <th className="text-left py-2">Produs</th>
                      <th className="text-right py-2">Cantitate</th>
                      <th className="text-right py-2">Preț Unitar</th>
                      <th className="text-right py-2">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedProcurement.items.map((item, index) => (
                      <tr key={index} className="border-b">
                        <td className="py-2">
                          <div className="font-medium">{item.product}</div>
                        </td>
                        <td className="text-right py-2">{item.quantity} {item.unit}</td>
                        <td className="text-right py-2">{item.unitPrice} RON</td>
                        <td className="text-right py-2 font-semibold">{item.total.toLocaleString()} RON</td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr className="border-t-2 font-semibold">
                      <td colSpan="3" className="py-2 text-right">TOTAL:</td>
                      <td className="text-right py-2 text-lg">{selectedProcurement.totalValue.toLocaleString()} {selectedProcurement.currency}</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>

            {/* Adresa de livrare */}
            <div className="border-t pt-6">
              <h3 className="text-lg font-semibold mb-2">Adresa de Livrare</h3>
              <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4">
                <div className="flex items-center space-x-2">
                  <Building className="w-4 h-4 text-gray-500" />
                  <span>{selectedProcurement.deliveryAddress}</span>
                </div>
              </div>
            </div>

            {/* Note și observații */}
            {selectedProcurement.notes && (
              <div className="border-t pt-6">
                <h3 className="text-lg font-semibold mb-2">Note & Observații</h3>
                <p className="text-gray-600 dark:text-gray-400 bg-blue-50 dark:bg-blue-900/20 p-3 rounded-lg border-l-4 border-blue-400">
                  {selectedProcurement.notes}
                </p>
              </div>
            )}

            {/* Acțiuni */}
            <div className="border-t pt-6">
              <div className="flex flex-wrap gap-3">
                <button className="btn-primary flex items-center space-x-2">
                  <Edit className="w-4 h-4" />
                  <span>Editează Comanda</span>
                </button>
                <button className="btn-secondary flex items-center space-x-2">
                  <Send className="w-4 h-4" />
                  <span>Trimite Email</span>
                </button>
                <button className="btn-secondary flex items-center space-x-2">
                  <Download className="w-4 h-4" />
                  <span>Export PDF</span>
                </button>
                <button className="btn-secondary flex items-center space-x-2">
                  <Eye className="w-4 h-4" />
                  <span>Urmărire Livrare</span>
                </button>
              </div>
            </div>
          </div>
        )}
      </Modal>

      {/* Modal Adaugă Comandă Nouă */}
      <Modal
        isOpen={isAddProcurementModalOpen}
        onClose={() => setIsAddProcurementModalOpen(false)}
        title="Creează Comandă Aprovizionare Nouă"
        size="xl"
      >
        <div className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="label">Furnizor</label>
              <select className="input">
                <option>Selectează furnizorul...</option>
                <option>Sika Romania SRL</option>
                <option>Mapei Romania</option>
                <option>Blastrac Romania SRL</option>
                <option>HTC Frank Romania</option>
                <option>Pilkington Romania</option>
                <option>Hoppe AG Romania</option>
              </select>
            </div>
            <div>
              <label className="label">Persoană de Contact</label>
              <input type="text" className="input" placeholder="ex: Ing. Mihai Georgescu" />
            </div>
            <div>
              <label className="label">Telefon Contact</label>
              <input type="tel" className="input" placeholder="ex: +40 742 123 456" />
            </div>
            <div>
              <label className="label">Email Contact</label>
              <input type="email" className="input" placeholder="ex: contact@furnizor.ro" />
            </div>
            <div>
              <label className="label">Data Comandă</label>
              <input type="date" className="input" />
            </div>
            <div>
              <label className="label">Data Livrare Dorită</label>
              <input type="date" className="input" />
            </div>
            <div>
              <label className="label">Prioritate</label>
              <select className="input">
                <option>Selectează prioritatea...</option>
                <option>înaltă</option>
                <option>normală</option>
                <option>scăzută</option>
              </select>
            </div>
            <div>
              <label className="label">Termeni de Plată</label>
              <select className="input">
                <option>Selectează termenii...</option>
                <option>15 zile</option>
                <option>30 zile</option>
                <option>45 zile</option>
                <option>60 zile</option>
                <option>90 zile</option>
              </select>
            </div>
            <div className="md:col-span-2">
              <label className="label">Note și Observații</label>
              <textarea className="input" rows="3" placeholder="Specificații suplimentare, instrucțiuni de livrare, etc."></textarea>
            </div>
          </div>
          
          <div className="flex justify-end space-x-3 border-t pt-4">
            <button 
              onClick={() => setIsAddProcurementModalOpen(false)}
              className="btn-secondary"
            >
              Anulează
            </button>
            <button className="btn-primary">
              Creează Comanda
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default MaterialProcurement;